export var RssWidgetIconType;
(function (RssWidgetIconType) {
    RssWidgetIconType[RssWidgetIconType["Square"] = 1] = "Square";
    RssWidgetIconType[RssWidgetIconType["Circle"] = 2] = "Circle";
    RssWidgetIconType[RssWidgetIconType["None"] = 3] = "None";
})(RssWidgetIconType || (RssWidgetIconType = {}));
export const rssWidgetStyleParams = {
    'widget-iconBackgroundType': { key: 'widget-iconBackgroundType' },
    'widget-iconColor': { key: 'widget-iconColor' },
    'widget-iconBackgroundColor': { key: 'widget-iconBackgroundColor' },
    'widget-iconColorNoBackground': { key: 'widget-iconColorNoBackground' },
};
//# sourceMappingURL=rss-widget.wix-params.js.map